document.addEventListener('DOMContentLoaded', () => {

    const heroSwiper = new Swiper('.hero-swiper', {
		slidesPerView: 1,
		loop: true,
		speed: 600,
		effect: "fade",
		autoplay: {
			delay: 4500,
		},
	});


	const gallerySwiper = new Swiper('.gallery-swiper', {
		loop: true,
		spaceBetween: 15,
		speed: 800,
		centeredSlides: true,
		autoplay: {
			delay: 3000,
		},
		pagination: {
			el: ".sw-dots",
			clickable: true,
		},
		navigation: {
			nextEl: '.sw-next',
			prevEl: '.sw-prev',
		},
		breakpoints: {
			320: {
				slidesPerView: 1.2,
			},
			700: {
				slidesPerView: 2,
			},
			900: {
				slidesPerView: 3,
			}
		}
	});

	const cardsSwiper = new Swiper('.cards-swiper', {
		loop: true,
		spaceBetween: 10,
		speed: 800,
		pagination: {
			el: ".cards-dots",
			clickable: true,
		},
		navigation: {
			nextEl: '.cards-next',
			prevEl: '.cards-prev',
		},
		breakpoints: {
			320: {
				slidesPerView: 1,
			},
			700: {
				slidesPerView: 2,
			},
			900: {
				slidesPerView: 3,
			}
		}
	});

	const eventsSwiper = new Swiper('.events-swiper', {
		loop: true,
		speed: 800,
		breakpoints: {
			320: {
				slidesPerView: 1,
			},
			900: {
				slidesPerView: 3,
			}
		},
		pagination: {
			el: ".sw-dots",
			clickable: true,
		},
		navigation: {
			nextEl: '.sw-next',
			prevEl: '.sw-prev',
		}
	});

	const historySwiper = new Swiper('#history-swiper', {
		slidesPerView: 1,
		effect: "fade",
		loop: true,
		fadeEffect: {
			"crossFade": true
		},
		navigation: {
			nextEl: '.sw-next',
			prevEl: '.sw-prev',
		},
		breakpoints: {
			700: {
				allowTouchMove: false,
				loop: false,
			}
		}
	});

	const yearSwiper = new Swiper('#history-year-swiper', {
		slidesPerView: 'auto',
		on: {
			click() {
				let slideIndex = this.clickedIndex;
				historySwiper.slideTo(slideIndex);
				yearSwiper.slides.forEach(slide => slide.classList.remove('active'));
				yearSwiper.slides[slideIndex].classList.add('active')
			},
		}
	});

	const reviewsSwiper = new Swiper('.reviews-swiper', {
		loop: true,
		speed: 800,
		slidesPerView: 1,
		autoHeight: true,
		effect: "fade",
		autoplay: {
			delay: 9000,
		},
		fadeEffect: {
			"crossFade": true
		},
		navigation: {
			nextEl: '.sw-next',
			prevEl: '.sw-prev',
		},
		pagination: {
			el: ".sw-dots",
			clickable: true,
		},
		breakpoints: {
			900: {
				autoHeight: false,
			}
		}
	});

	const suitesSwiper = new Swiper('.suites-images', {
		loop: true,
		speed: 800,
		slidesPerView: 1,
		pagination: {
			el: ".sw-dots",
			clickable: true,
		}
	});


	const sliderSwiper = new Swiper('.slider-swiper', {
		loop: true,
		slidesPerView: 1,
		speed: 800,
		effect: "fade",
		fadeEffect: {
			"crossFade": true
		},
		navigation: {
			nextEl: ".sw-next",
			prevEl: ".sw-prev",
		},
		pagination: {
			el: ".sw-dots",
			clickable: true,
		}
	});


	document.querySelectorAll('.columns-swiper').forEach(slider => {
		let swiperID = slider.getAttribute("data-id");
		const colSwiper = new Swiper(slider, {
			loop: true,
			speed: 800,
			navigation: {
				nextEl: `.sw-next-${swiperID}`,
				prevEl: `.sw-prev-${swiperID}`,
			},
			pagination: {
				el: `.col-sw-dots-${swiperID}`,
				clickable: true,
			},
			breakpoints: {
				320: {
					slidesPerView: 1,
				},
				900: {
					slidesPerView: 3,
					spaceBetween: 40
				}
			}
		});
	});
});